<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'file-invoice']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('global.invoicing_settings') }}
        </span>
      </div>
    </template>
    <template #cta>
      <BaseButton
        v-if="$can('manage_settings')"
        color="warning"
        :icon="editionMode ? 'times' : 'pen'"
        @click="getSettingsAndChangeEditionMode"
        :title="editionMode ? $t('button.cancel') : $t('button.edit')"
      />
    </template>

    <template #body>
      <div class="space-y-8">
        <PageSection
          disable-sticky-margin
          :title="$t('global.general_information')"
        >
          <div class="grid-form">
            <div>
              <BaseDocShowEditSelectMultiple
                v-model="settings.available_docs"
                :editionMode="editionMode"
                :metadata="metadata"
                :required="true"
                :errors="errors"
              />
            </div>
            <div>
              <BaseShowEditInput
                :label="$t('attributes.default_deadLine')"
                :placeholder="$t('attributes.default_deadLine')"
                v-model="settings.default_deadLine"
                type="number"
                parseType="int"
                :min="1"
                :max="9999999"
                :editionMode="editionMode"
                :errors="errors.simultaneous_cremation"
                :required="true"
              />
            </div>
          </div>
        </PageSection>
      </div>
      <div class="mt-4 flex justify-end">
        <BaseButton
          v-if="editionMode"
          :isElevated="true"
          icon="paper-plane"
          @click="submitForm"
          :title="
            $t('button.save_plural', { var: $t('global.invoicing_settings') })
          "
        />
      </div>
    </template>
  </SettingsPageFull>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'InvoicingInfosTabComponent',
  data() {
    return {
      editionMode: false
    }
  },
  computed: {
    ...mapGetters({
      settings: 'settings/getSettings',
      metadata: 'settings/getSettingsMetadata',
      errors: 'auth/getErrors'
    }),
    permission() {
      return !this.$can('manage_settings')
    }
  },
  methods: {
    ...mapActions({
      fetchInvoicingSettings: 'settings/fetchInvoicingSettings',
      updateInvoicingSettings: 'settings/updateInvoicingSettings'
    }),
    submitForm() {
      this.updateInvoicingSettings({
        invoicingSettings: this.settings
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.updated_plurals', {
            var: this.$t('global.invoicing_settings')
          })
        )
        this.editionMode = false
      })
    },
    getSettingsAndChangeEditionMode() {
      if (this.editionMode) {
        this.fetchInvoicingSettings()
      }
      this.editionMode = !this.editionMode
    }
  },
  beforeMount() {
    this.fetchInvoicingSettings()
  }
}
</script>
